
import { css } from "@emotion/react";
import { rem } from "@util/convertUnits";
import Header from "@/base/Header";
import Kicker from "@/base/Kicker";
import GenericPageBanner from "@/core/common/GenericPageBanner";
import RequestServiceForm from "./components/RequestServiceForm";
import FormPrivacyPolicy from './components/FormPrivacyPolicy';
import HelmetBuilder from "@/base/HelmetBuilder";

const RequestServiceFormPage = () => {

  const formCss = css(`
    width: 100%;
    max-width: ${rem(520)};
    margin-left: auto;
    margin-right: auto;
  `);

  const buildMeta = () => {

    let data = {
      title: `Request Service | LaCantina Doors`,
      description: `Request Service`,
      keywords: 'BiFold Doors, Accordion, Folding Glass, Multi Slide, Swing Doors & Windows!',
    }

    return <HelmetBuilder data={data} preview={false} />
  }

  return (
    <div>
      {buildMeta()}
      <GenericPageBanner image="/images/banners/generic.jpg" localImage={true}>
        <Kicker stylesOverride={{ textShadow: "0 0 1rem rgb(255,255,255)" }}>Support</Kicker>
        <Header tag="h1" style={{ textShadow: "0 0 1.5rem rgba(255,255,255,0.8)" }}>Customer Service Request</Header>
      </GenericPageBanner>

      <div className="container m-gap">
        <RequestServiceForm />
        <div css={formCss}>
          <FormPrivacyPolicy />
        </div>

      </div>
    </div>
  );
};
export default RequestServiceFormPage;
